import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexModule } from '@ngbracket/ngx-layout';
import { ModalModule, UiModule } from '@eg/ui';
import { CopyPopupComponent } from './copy-popup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedDirectiveModule } from '@railmybox/shared/directive';

@NgModule({
  declarations: [CopyPopupComponent],
  imports: [CommonModule, TranslocoModule, FlexModule, ReactiveFormsModule, ModalModule, UiModule, SharedDirectiveModule],
  exports: [CopyPopupComponent],
})
export class CopyPopupModule {}
